@layer design-system {
  .root {
    width: 100%;
    cursor: pointer;
  }
}
